import UserAccessPanel from './UserAccessPanel';

export default UserAccessPanel;